import { useQuery } from "@tanstack/react-query";

import type { LeadsSearchRequestDto, LeadsSearchResponseDto } from "app/pages/sales-intelligence/modules/leads-search";
import { getMainCompanyDomainOrDefault } from "app/pages/sales-intelligence/modules/leads-search/utils/rows";
import { opportunityListQueryKeyFactory } from "app/pages/sales-intelligence/pages/opportunity-list/query/queryKeyFactory";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { useListParams } from "../context/ListParamsContext";

const DTO: LeadsSearchRequestDto = { pageSize: 9999, page: 1, queryFilters: {} };

const selectData = (data: LeadsSearchResponseDto) =>
    data.rows?.map((row) => {
        const domain = getMainCompanyDomainOrDefault(row).domain;

        return { company: row.company ?? domain, domain, icon: row.favicon };
    }) ?? [];

export const useCompaniesListFullData = () => {
    const listParams = useListParams();

    const { data: queryData } = useQuery({
        queryKey: opportunityListQueryKeyFactory.leadsTableData(listParams.id, "companies", DTO),
        queryFn({ signal }: { signal: AbortSignal }) {
            return salesApiService.opportunityListPage.fetchLeadsSearchResults(
                {
                    listParams,
                    leadsType: "companies",
                    dto: DTO,
                },
                { cancellation: signal },
            );
        },
        select: selectData,
    });

    return queryData ?? [];
};
